module.exports = __webpack_public_path__ + "static/img/bg.51a129b.jpg";